const convertArrayToText = function (data, propiedad, option = 1) {
  let texto = ''
  if (propiedad !== '') {
    for (let i = 0; i < data.length; i++) {
      texto = texto + ` ${data[i][propiedad]},`
    }
  } else {
    for (let i = 0; i < data.length; i++) {
      texto = texto + ` ${data[i]},`
    }
  }

  if (option === 1) {
    return texto.substring(0, texto.length - 1)
  } else {
    return texto
  }
}

export default convertArrayToText



// WEBPACK FOOTER //
// ./src/global-services/arrayToText.js